/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bidbattle__Status__Paused6Inputs */

const en_bidbattle__status__paused6 = /** @type {(inputs: Bidbattle__Status__Paused6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paused`)
};

/**
* | output |
* | --- |
* | "Paused" |
*
* @param {Bidbattle__Status__Paused6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const bidbattle__status__paused6 = /** @type {((inputs?: Bidbattle__Status__Paused6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bidbattle__Status__Paused6Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bidbattle__status__paused6(inputs)
});
export { bidbattle__status__paused6 as "bidbattle__status__PAUSED" }